import React from 'react';
import { t } from 'i18next';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useNavigate } from 'react-router-dom';
import { isPlayfulTheme } from '@/lib/layout-version';

export function CourseTabs({ selectedTab }) {
  const navigate = useNavigate();
  // Aba ativa chanfrada (relevo 3D igual aos botões): laranja + texto branco + lip escuro.
  const playfulTab = isPlayfulTheme()
    ? 'data-[state=active]:bg-[var(--color-mission)] data-[state=active]:text-white data-[state=active]:font-extrabold data-[state=active]:shadow-[0_3px_0_var(--color-mission-dark)] data-[state=active]:-translate-y-px'
    : undefined;
  const tabs = [
    { value: 'curso', label: t('courses.toggleMyCourses'), path: '/curso' },
    // { value: 'recomendado', label: 'Recomendados', path: '/curso/recomendado' },
    { value: 'certificados', label: t('lms.toggleCertifications'), path: '/curso/certificado' }
  ];

  return (
    <Tabs defaultValue={selectedTab}>
      <TabsList className={isPlayfulTheme() ? 'border border-neutral-lighter bg-white' : 'mb-8'}>
        {tabs.map(tab => (
          <TabsTrigger
            key={tab.value}
            value={tab.value}
            className={playfulTab}
            onClick={() => navigate(tab.path)}
          >
            {tab.label}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
